
<div class="container">
<div class="pt-2">
<h1 class="page-title">{{ heading1 }}</h1>
</div>
<div class="hover-red">
<a tabindex="0" class="hover-red btn btn-link" (click)="onPrevious()">
<svg
xmlns="http://www.w3.org/2000/svg"
width="16.875"
height="15.75"
viewBox="0 0 16.875 15.75"
>
<g
id="_icons_arrow-back-outline"
data-name="⚛️ icons/arrow-back-outline"
transform="translate(0)"
>
<path
id="Combined_Shape"
data-name="Combined Shape"
d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
transform="translate(0)"
fill="#174a7c"
/>
</g>
</svg>
<span class="ps-2">Back to TennCare Access Welcome page</span>
</a>
</div>
<div>
<div class="py-4">
<div class="card">
<div class="page_label p-4">
<h2 class="section-header">{{ heading2 }}</h2>
<hr />
<p>
{{ heading3 }}
<span
>@if (!isNewborn) {
<nh-popover
style="padding-left: 1px"
content="{{ 'ADMIT_DISCHARGE_POPUP' | translate }}"
></nh-popover>
}</span
>
</p>
@if (isNewborn) {
<div>
<p>
{{ heading4 }}
<a
class="page-info btn-link underline-link"
href="https://www.tn.gov/content/dam/tn/tenncare/documents/BirthReportingFormEng.pdf"
target="_blank"
title="Click here"
aria-label="Click here"
aria-describedby="birth-form-desc"
>Click here</a
>
to download the Birth Reporting Form for a Safe Haven Baby.
</p>


</div>
}
<form [formGroup]="searchForm">
<div>
@if (showSearchByNameMessage) {
<div>
<nh-alert type="danger" [isOpen]="true">
<div class="row">
<div class="col-auto icon">
<img
src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
alt="danger"
/>
</div>
<div
role="alert"
aria-live="assertive"
tabindex="-1"
class="col message"
>
<span
>You must enter a member's first name, last name, and
date of birth to search by name.</span
>
</div>
</div>
</nh-alert>
</div>
}
<div class="row g-3">
<div class="col-sm-8 col-lg-3 col-md-3">
<nh-field
[attr.aria-required]="true"
[isRow]="true"
[mandatory]="true"
label="{{ 'FIRST_NAME' | translate }}"
>
<input
type="text"
aria-label="firstName"
name="firstName"
(change)="validateName($event)"
formControlName="firstName"
class="form-control"
maxlength="45"
required
/>
</nh-field>
</div>
<div class="col-sm-4 col-lg-2 col-md-2">
<nh-field
[attr.aria-required]="false"
[isRow]="true"
[mandatory]="false"
label="{{ 'MIDDLE_NAME' | translate }}"
>
<input
aria-label="middleInitial"
type="text"
name="middleInitial"
formControlName="middleInitial"
class="form-control"
mask="S"
/>
</nh-field>
</div>
<div class="col-sm-8 col-lg-3 col-md-3">
<nh-field
[attr.aria-required]="true"
[isRow]="true"
[mandatory]="true"
label="{{ 'LAST_NAME' | translate }}"
>
<input
aria-label="lastName"
type="text"
name="lastName"
(change)="validateName($event)"
formControlName="lastName"
class="form-control"
maxlength="45"
required
/>
</nh-field>
</div>
<div class="col-sm-4 col-lg-2 col-md-2">
<label for="proofType" class="label-section">Suffix</label>
<select
aria-label="suffix"
class="custom-select-info"
formControlName="suffix"
(change)="selectedOption($event)"
>
<option [ngValue]="null">Pick an option</option>
@for (option of options; track option) {
<option [ngValue]="option">
{{ option.enDescription }}
</option>
}
</select>
</div>
</div>
</div>
<div class="row g-3">
<div class="col-sm-12 col-md-6">
<nh-field
[attr.aria-required]="true"
label="Date of Birth"
[mandatory]="true"
class="label-section"
>
<nh-datepicker>
<input
type="text"
class="form-control"
name="dateOfBirth"
formControlName="dateOfBirth"
aria-label="dateOfBirth"
(bsValueChange)="validateName($event)"
(change)="validateName($event)"
placeholder="mm/dd/yyyy"
[minDate]="minimumDate"
[maxDate]="today"
bsDatepicker
nh
required
/>
</nh-datepicker>
</nh-field>
</div>
</div>
<div class="row g-3 horizontal-border">
<p class="and-border" style="width: 45%"></p>
<p
class="text-center middle-text"
style="width: 5%; padding-bottom: 15px"
>
<strong>OR</strong>
</p>
<p class="and-border" style="width: 45%"></p>
</div>
<div class="row g-3">
<div class="col-sm-12 col-md-3">
<nh-field
[attr.aria-required]="true"
[mandatory]="true"
[isRow]="true"
label="Social Security Number"
class="label-section"
>
<input
aria-label="ssn"
type="text"
name="ssn"
formControlName="ssn"
class="form-control"
(change)="validateSsn()"
placeholder="XXX-XX-XXXX"
mask="000-00-0000"
required
/>
</nh-field>
</div>
</div>
<div class="row g-3 horizontal-border">
<p class="and-border" style="width: 45%"></p>
<p
class="text-center middle-text"
style="width: 5%; padding-bottom: 15px"
>
<strong>OR</strong>
</p>
<p class="and-border" style="width: 45%"></p>
</div>
<div class="row g-3">
<div class="col-sm-12 col-md-5">
<nh-field
[attr.aria-required]="true"
[mandatory]="true"
label="Person ID"
class="label-section"
>
<input
aria-label="personId"
type="text"
name="personID"
(change)="validateIndvId()"
formControlName="personID"
class="form-control"
mask="9999999999"
required
/>
</nh-field>
</div>
</div>
</form>


<div class="row g-3">
<div class="col-12 col-md-3 py-2 py-md-0 order-md-1">
<button
class="btn btn-secondary"
(click)="onSearch()"
[disabled]="!isFormValid"
>
Search&nbsp; <i class="fa fa-search"></i>
</button>
</div>
</div>


<div [formGroup]="searchForm">
@if (showSearch) {
<h2 class="section-header">Search Results</h2>
}
<hr />
@if (isNewborn && (rows | async) && result && result.length) {
<div>
<ngx-datatable
class="bootstrap striped"
#table
[rows]="result"
columnMode="force"
[headerHeight]="50"
[footerHeight]="50"
[rowHeight]="'auto'"
[limit]="5"
>
@for (col of columns; track col) {
<ngx-datatable-column
[name]="col.name"
[prop]="col.prop"
></ngx-datatable-column>
}
<ngx-datatable-column name="Select" [width]="180">
<ng-template
ngx-datatable-cell-template
let-row="row"
let-rowIndex="rowIndex"
>
<div class="d-flex">
<a
class="select-open_in_new view-tennCare-title"
tabindex="0"
[attr.aria-label]="row.appTypeText"
(click)="startApplication(row)"
(keydown.enter)="startApplication(row)"
(keydown.space)="
startApplication(row); $event.preventDefault()
"
>
{{ row.appTypeText }}
<i
class="fa fa-external-link"
aria-hidden="true"
role="presentation"
tabindex="-1"
></i>
</a>
</div>
</ng-template>
</ngx-datatable-column>
</ngx-datatable>
</div>
} @if (!isNewborn && (rows | async) && result && result.length) {
<div class="page_label mt-3">
<ngx-datatable
class="bootstrap striped"
#table
[rows]="result"
[columnMode]="'force'"
[headerHeight]="50"
[footerHeight]="50"
[rowHeight]="'auto'"
[limit]="limit"
[selectionType]="'single'"
[selected]="selected"
(select)="onSelect($event)"
[selectCheck]="singleSelectCheck"
>
@for (col of columns; track col) {
<ngx-datatable-column
[name]="col.name"
[prop]="col.prop"
></ngx-datatable-column>
}
<ngx-datatable-column name="Select">
<ng-template
ngx-datatable-cell-template
let-row="row"
let-rowIndex="rowIndex"
let-value="value"
let-isSelected="isSelected"
let-onCheckboxChangeFn="onCheckboxChangeFn"
>
@if (row.isMedicaidEligible) {
<input
aria-label="select"
type="checkbox"
name="select"
formControlName="select"
[checked]="isSelected"
(change)="onCheckboxChangeFn($event)"
/>
} @if (!row.isMedicaidEligible) {
<p>
<strong>Stop</strong> This form can't be submitted because
this person is not receiving Institutional Medicaid
coverage. Fill out an application and tell us this person
needs nursing home care.
<span
><nh-popover
style="padding-left: 1px"
content="{{ 'ADMIT_DISCHARGE_SEARCH' | translate }}"
></nh-popover
></span>
</p>
}
</ng-template>
</ngx-datatable-column>
</ngx-datatable>
</div>
}
</div>
@if (result && result.length) {
<div class="pull-right">
<p>Results Shown {{ result.length }}</p>
</div>
} @if (result && !result.length && showSearch && isNewborn) {
<div>


<p>
We could not find the person you searched for. If this person has
not already been approved, please submit a
<a
tabindex="0"
class="view-tennCare-title"
(click)="startApp('HPE')"
>hospital presumptive application</a
>
for the mother and newborn.
</p>
</div>
} @if (result && !result.length && showSearch && !isNewborn) {
<div>


<p>
We could not find the person you searched for. If this person is
not enrolled in TennCare, please
<a
tabindex="0"
class="view-tennCare-title"
(click)="startApp('AFB')"
>Apply For Coverage.</a
>
After submitting the application, please wait 24-48 hours before
returning to complete the 2350 Form.
</p>
</div>
}
</div>
</div>
</div>
@if (!isNewborn) {
<div class="my-3">
<button
id="continue"
aria-label="Next"
[disabled]="nextDisaled"
(click)="startApplication()"
class="col-md-2 btn d-grid btn-secondary"
>
{{ "NEXT" | translate }}
</button>
</div>
}
</div>
</div>
 